<template lang="pug">
  div
    v-snackbar(v-model='snackbar.snackbar' :color='snackbar.color' :center="true" :timeout='snackbar.timeout' :top="true")
      | {{ snackbar.text }}
      v-btn(dark='' text='' @click='snackbar.snackbar = false')
        | {{$t('payment.general.close')}}
    v-dialog(persistent :value='subscriptionDialog' max-width='1000px' transition="dialog-bottom-transition")
      div(style ='position:relative; height: 100%; background:#fff;')
        pricing(@close="")
    v-dialog(persistent :value='dialogProfile' max-width='600px' :fullscreen="isMobile" transition="dialog-bottom-transition")
      div(style ='position:relative; height: 100%;')
        profile-dialog(@close="dialogProfile=false")
    v-navigation-drawer#core-navigation-drawer(fixed v-model="drawer" :dark="barColor !== 'rgba(228, 226, 226, 1), rgba(255, 255, 255, 0.7)'" :expand-on-hover="expandOnHover" :right="$vuetify.rtl" :src="barImage" mobile-break-point="960" app="" mini-variant-width="80" width="260" v-bind="$attrs")
      template(v-slot:img="props")
        v-img(:gradient="`to bottom, ${barColor}`" v-bind="props")
      v-list-item(three-line="")
        v-list-item-content
          v-list-item-title(style="display:flex").align-center.text-uppercase.font-weight-regular.display-2
            v-img(:src='logo' max-width="160px")
            div(@click='toggleSupport' style="max-width: 50px; font-size: 14px").text-center.ml-auto.text-capitalize.support-button
              v-img(height='30px' width='30px'  contain :src='supportIcon').mx-auto
              | soporte
      v-divider.mb-1
      v-list(dense="" nav="")
        base-item-group(:item="profile")
      v-divider.mb-2
      // Shops
      v-list(expand="" nav="")
        template(v-for="(item, i) in shopsNav")
          base-item(v-if="!item.children" :key="`item-${i}`" :item="item")
          base-item-group(v-if="item.children && item.children.length > 0" :key="`group-${i}`" :item="item")
          v-divider(v-if="i !== shopsNav.length-1")
      v-divider.mb-2
      // Routes
      v-list(expand="" nav="")
        template(style='position:relative;' v-for="(item, i) in computedItems")
          base-item-group(v-if="item.children" :key="`group-${i}`" :item="item")
          base-item(v-else-if='user.role!=="Colaborador" || (user.role==="Colaborador" && item.group !== "/dashboard/collaborators" && item.group !== "/dashboard/plans"  && item.group !== "/dashboard/referrals")' :key="`item-${i}`" :item="item")
          v-divider(v-if="i !== computedItems.length-1")
          v-alert.tutorial-alert(v-if="user && profileData && profileData.showTutorial && !isMobile && i === stepsTutorial" :color="tutorial[stepsTutorial].color")
            v-row
              h3.headline {{tutorial[stepsTutorial].title}}
              v-spacer
              v-btn(@click="profileData.showTutorial = false" fab small text).ml-auto.align-start
                v-icon() mdi-close
            div
              | {{tutorial[stepsTutorial].description}}
            v-divider.my-4.info(style="opacity: 0.22")
            v-checkbox(v-if="tutorial.length-1 === stepsTutorial" v-model="showTutorial" v-bind:label="$t('drawer.dont_show_again')" color="white" value="white" hide-details="")
            div.text-right
                v-btn(v-if="stepsTutorial > 0" color="white" text small @click="backStep")
                  | Anterior
                v-btn(color="white" text small @click="changeStep")
                  span(v-if="tutorial.length-1 === stepsTutorial") Terminar
                  span(v-else) Siguiente
      v-divider.mb-2
      <!--v-list-item(two-line="")-->
        <!--v-list-item-content-->
          <!--v-list-item-title.text-uppercase.font-weight-regular.display-2-->
            <!--span.logo-mini TP-->
            <!--span.logo-normal TEMPLATE-->
      <!--v-list(expand="" nav="")-->
        <!--template(v-for="(item, i) in items_sample")-->
          <!--base-item-group(v-if="item.children" :key="`group-${i}`" :item="item")-->
          <!--base-item(v-else-if='user.role!=="Colaborador" || (user.role==="Colaborador" && item.group !== "/collaborators")' :key="`item-${i}`" :item="item")-->

</template>

<script>
  import loaders from '@/plugins/mixins/loaders'
  import pricing from '@/views/custom/pricing/Pricing'
  import profileDialog from '@/components/custom/dialogs/profileDialog'
  import supportIcon from '@/assets/icons/support.png'
  import logo from '@/assets/logo-2-w-small.png'
  // import * as firebase from 'firebase'
  // Utilities
  export default {
    name: 'DashboardCoreDrawer',

    components: {
      profileDialog: profileDialog,
      pricing: pricing,
    },

    mixins: [
      loaders,
    ],

    props: {
      expandOnHover: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      supportIcon: supportIcon,
      showTutorial: false,
      stepsTutorial: 0,
      tutorial: [
        { title: 'Indice', description: 'Aqui encontraras los enlaces mas usados y tutoriales para que puedas aprender a usar Tender', color: 'info' },
        { title: 'Metricas', description: 'Revisa las estadísticas de crecimiento de tus negócios, mira datos como Número de pedidos, compras, ventas, ordenes de tienda virtual, entre otros', color: 'info' },
        { title: 'Movimientos', description: 'En esta sección encontrarás todos aquellos movimientos que realices dentro de tu tienda, tales como facturas de compra, ventas, traslados, devoluciones, ordenes, etc.', color: 'warning' },
        { title: 'Productos', description: 'Aquí, podrás agregar y editar los productos del inventario dentro de tus tiendas, ya sean productos simples, combos, ingredientes y servicios', color: 'error' },
        { title: 'Proveedores', description: 'Gestiona los proveedores de tu negocio, agregalos para luego poder generar facturas de compra', color: 'success' },
        { title: 'Clientes', description: 'Tus clientes son los más importante, actualiza sus datos, agrega nuevos clientes incluyendo los de tu tienda virtual', color: 'info' },
        { title: 'Colaboradores', description: 'Gestiona tu equipo de ventas, crea tus vendedores y colaboradores para llevar un control de ventas en tu negocio', color: 'warning' },
        { title: 'Notificaciones', description: 'Tender te notificará cuando lleguen nuevos pedidos realizados en tu tienda virtual', color: 'warning' },
        /* { title: 'Plaza virtual', description: 'Has pedidos a otras tiendas, busca y encuentra lo que necesites', color: 'warning' }, */
        { title: 'Mi Suscripción', description: 'Crece con Tender, mejora tu plan, encontraras mejores beneficios para tu negocio. ', color: 'primary' },
      ],
      shopsArr: [],
      collaboratorsList: [],
      snackbar: {
        color: '',
        snackbar: false,
        text: '',
        timeout: 6000,
      },
      bandViewShop: false,
      dialogSubscription: false,
      dialogProfile: false,
      items_sample: [
        {
          icon: 'mdi-view-dashboard',
          title: 'dashboard',
          to: '/',
        },
        {
          group: '/pages',
          icon: 'mdi-image',
          title: 'pages',
          children: [
            {
              title: 'pricing',
              to: 'pricing',
            },
            {
              title: 'rtl',
              to: 'rtl',
            },
            {
              title: 'timeline',
              to: 'timeline',
            },
            {
              title: 'login',
              to: 'login',
            },
            {
              title: 'register',
              to: 'pricing',
            },
            {
              title: 'lock',
              to: 'lock',
            },
            {
              title: 'user',
              to: 'user',
            },
            {
              title: 'error',
              to: '404',
            },
          ],
        },
        {
          group: '/components',
          icon: 'mdi-view-comfy',
          title: 'components',
          children: [
            {
              title: 'multi',
              group: '',
              children: [
                {
                  title: 'example',
                  href: '#',
                },
              ],
            },
            {
              title: 'buttons',
              to: 'buttons',
            },
            {
              title: 'grid',
              to: 'grid-system',
            },
            {
              title: 'tabs',
              to: 'tabs',
            },
            {
              title: 'notifications',
              to: 'notifications',
            },
            {
              title: 'icons',
              to: 'icons',
            },
            {
              title: 'typography',
              to: 'typography',
            },
          ],
        },
        {
          group: '/forms',
          icon: 'mdi-clipboard-outline',
          title: 'forms',
          children: [
            {
              title: 'rforms',
              to: 'regular',
            },
            {
              title: 'eforms',
              to: 'extended',
            },
            {
              title: 'vforms',
              to: 'validation',
            },
            {
              title: 'wizard',
              to: 'wizard',
            },
          ],
        },
        {
          group: '/tables',
          icon: 'mdi-grid',
          title: 'tables',
          children: [
            {
              title: 'rtables',
              to: 'regular-tables',
            },
            {
              title: 'etables',
              to: 'extended-tables',
            },
            {
              title: 'dtables',
              to: 'data-tables',
            },
          ],
        },
        {
          group: '/maps',
          icon: 'mdi-map-marker',
          title: 'maps',
          children: [
            {
              title: 'google',
              to: 'google-maps',
            },
            {
              title: 'fullscreen',
              to: 'full-screen-map',
            },
          ],
        },
        {
          icon: 'mdi-widgets',
          title: 'widgets',
          to: '/widgets',
        },
        {
          icon: 'mdi-chart-timeline-variant',
          title: 'charts',
          to: '/charts',
        },
        {
          icon: 'mdi-calendar-range',
          title: 'calendar',
          to: '/calendar',
        },
      ],
      logo,
    }),

    computed: {
      isMobile () {
        return window.innerWidth < 1024
      },
      subscriptionDialog () {
        return this.$store.state.subscriptions.subscriptionDialog
      },
      selectedPlan () {
        return this.$store.state.subscriptions.selectedPlan
      },
      barColor () {
        return this.$store.state.drawer.barColor
      },
      barImage () {
        return this.$store.state.drawer.barImage
      },
      profileData () {
        return this.$store.state.users.profile
      },
      user () {
        return this.$store.state.users.user
      },
      shops () {
        return this.$store.getters['shops/getItems']
      },
      shopsList () {
        const children = []
        if (this.shops) {
          this.shops.forEach(element => {
            // console.log(element.name, element.id)
            children.push({ title: element.name, to: element.id })
          })
          return children
        } else {
          return children
        }
      },
      shopsNav () {
        const shopsList = [
          {
            icon: 'mdi-plus',
            title: this.$t('drawer.create_store'),
            to: '/dashboard/create-shop',
          },
          {
            group: '/dashboard/shops',
            icon: 'mdi-home',
            title: this.$t('drawer.my_stores'),
            children: [...this.shopsList],
          },
        ]

        if (this.isMobile) {
          const shops = {
            group: '/dashboard/shopsList',
            icon: 'mdi-home',
            title: this.$t('drawer.my_stores'),
            to: '/dashboard/shops-list',
          }
          shopsList.splice(1, 1, shops)
        }

        return shopsList
      },
      items () {
        const drawerItems = [
          {
            icon: 'mdi-view-dashboard',
            title: this.$t('drawer.index'),
            to: '/dashboard',
          },
          {
            icon: 'mdi-poll',
            title: 'Metricas',
            to: '/dashboard/metrics',
          },
          {
            group: '/dashboard/transactions',
            icon: 'mdi-swap-horizontal-circle-outline',
            title: this.$t('drawer.movements'),
            children: [
              {
                title: this.$t('drawer.sales'),
                to: 'sales',
              },
              {
                title: this.$t('drawer.orders'),
                to: 'orders',
              },
              {
                title: this.$t('drawer.purchases'),
                to: 'purchases',
              },
              {
                title: this.$t('drawer.transfers'),
                to: 'transfers',
              },
              {
                title: this.$t('drawer.expenses'),
                to: 'expenses',
              },
              {
                title: this.$t('drawer.returns'),
                to: 'returns',
              },
              {
                title: this.$t('drawer.logs'),
                to: 'logs',
              },
              {
                title: 'Cambio de inventario',
                to: 'inventory',
              },
              {
                title: this.$t('drawer.summary'),
                to: 'summary',
              },
            ],
          },
          {
            group: '/dashboard/products',
            icon: 'mdi-cube-outline',
            title: this.$t('drawer.products'),
            to: '/dashboard',
            children: [
              {
                icon: 'mdi-format-list-bulleted-square',
                title: this.$t('drawer.products_list'),
                to: '#',
              },
              {
                icon: 'arrow-up-circle-outline',
                title: this.$t('drawer.load_inventory'),
                to: 'inventory',
              },
            ],

          },
          /* {
            group: '/dashboard/add-inventory',
            icon: 'mdi-card-account-phone',
            title: this.$t('drawer.add_inventory'),
            to: '/dashboard/transactions/add-inventory',
          }, */
          {
            group: '/dashboard/providers',
            icon: 'mdi-card-account-phone',
            title: this.$t('drawer.supliers'),
            to: '/dashboard/providers',
          },
          {
            group: '/dashboard/clients',
            icon: 'mdi-account-cash',
            title: this.$t('drawer.clients'),
            to: '/dashboard/clients',
          },
          {
            group: '/dashboard/collaborators',
            icon: 'mdi-account-tie-outline',
            title: this.$t('drawer.collaborators'),
            to: '/dashboard/collaborators',

          },
          {
            group: '/dashboard/notifications',
            icon: 'mdi-bell',
            title: this.$t('notifications'),
            to: '/dashboard/notifications',
          },
          /* {
            group: '/dashboard/storefront',
            icon: 'mdi-home',
            title: this.$t('drawer.landing'),
            to: '/',

          }, */
          {
            group: '/dashboard/plans',
            icon: 'mdi-wallet-giftcard',
            title: this.$t('drawer.upgrade_plan'),
            to: '/dashboard/plans',

          },
        ]
        if (this.$store.state.users.profile && this.$store.state.users.profile.canHaveReferrals) {
          const referralsItem = {
            group: '/dashboard/referrals',
            icon: 'mdi-share-variant',
            title: 'Referidos',
            to: '/referals/referralsInfo',
          }
          drawerItems.splice(6, 0, referralsItem)
        }
        if (this.isMobile) {
          const movements = {
            group: '/dashboard/transactions-list',
            icon: 'mdi-swap-horizontal-circle-outline',
            title: this.$t('drawer.movements'),
            to: '/dashboard/transactions-list',
          }
          drawerItems.splice(2, 1, movements)
          const tutorials = {
            group: '/dashboard/tutorials',
            icon: 'mdi-youtube',
            title: 'Tutoriales',
            to: '/dashboard/tutorials',
          }
          drawerItems.splice(8, 0, tutorials)
        }
        return drawerItems
      },

      drawer: {
        get () {
          // console.log(this.$store.state.drawer.drawer)
          return this.$store.state.drawer.drawer
        },
        set (val) {
          // console.log(val, this)
          this.$store.dispatch('drawer/set_drawer', val)
        },
      },
      computedItems () {
        return this.items.map(this.mapItem)
      },
      profile () {
        return {
          avatar: true,
          group: '',
          // title: this.$t('avatar'),
          title: this.$store.state.users.user.email,
          children: [
            {
              title: this.$t('my-profile'),
              to: 'dashboard/profile',
            },
            /* {
              title: this.$t('edit-profile'),
              to: 'collaborators',
            },
            {
              title: this.$t('settings'),
              to: 'collaborators',
            }, */
          ],
        }
      },
    },

    watch: {
      '$vuetify.breakpoint.smAndDown' (val) {
        this.$emit('update:expandOnHover', !val)
      },
    },

    created () {
      const vm = this
      this.getDtaRestrictions()
      vm.getProfile()
      vm.loadLocations()
      vm.loadProducts()
      this.$store.dispatch('drawer/set_drawer', true)
    },
    mounted () {
      setTimeout(() => {
        this.$store.dispatch('users/getCollaborators').then(res => {
          this.collaboratorsList = res
          this.shopsArr = this.$store.getters['shops/getItems']
          const data = {
            shops: this.shopsArr,
            collaborators: this.collaboratorsList,
          }
          this.$store.dispatch('payment/getSubscriptionData', data)
        })
      }, 1000)
    },

    methods: {
      toggleSupport () {
        // this.$drift.api.sidebar.toggle()
      },
      backStep () {
        const vm = this
        vm.stepsTutorial--
      },
      changeStep () {
        const vm = this
        vm.stepsTutorial++
        if (vm.stepsTutorial >= vm.tutorial.length) {
          if (vm.showTutorial) {
            const profile = {
              showTutorial: false,
            }
            vm.$store.dispatch('users/updateProfile', profile)
          }
          vm.profileData.showTutorial = false
          // vm.stepsTutorial = 10
        }
      },
      mapItem (item) {
        return {
          ...item,
          children: item.children ? item.children.map(this.mapItem) : undefined,
          title: this.$t(item.title),
        }
      },
      validateProfile (profile) {
        const vm = this
        // console.log(profile)
        if (!profile || !profile.name || !profile.last_name || !profile.phone) {
          vm.dialogProfile = true
          // console.log(profile)
        }
      },
      setDataNotification (ban, color, text) {
        this.snackbar.snackbar = ban
        this.snackbar.color = color
        this.snackbar.text = text
      },
      getDtaRestrictions () {
        // firebase.database().ref(`users/${this.user.uid}/shops`).on('value', (snapshot) => {
        //   const res = snapshot.val()
        //   let totalShops = 0
        //   if (res != null) {
        //     const arr = Object.keys(res).map(card => {
        //       return { id: card, data: res[card] }
        //     })
        //     totalShops = arr.length
        //   }
        //   this.$store.dispatch('users/getRestrictions').then(res => {
        //     // console.log(res)
        //     const salePointRestriction = res.salePoints
        //     if (salePointRestriction > totalShops) {
        //       this.bandViewShop = true
        //     } else {
        //       this.bandViewShop = false
        //     }
        //   }, rej => {
        //     this.setDataNotification(true, 'error', this.$t('shop.createModule.errorGetRestriction'))
        //   })
        // }, (error) => {
        //   // console.log(error)
        //   this.setDataNotification(true, 'error', this.$t('shop.createModule.errorGetRestriction'))
        // })
      },
      getProfile () {
        const vm = this
        const profilData = vm.$store.state.users.profile
        // console.log(profilData)
        if (profilData) {
          vm.validateProfile(profilData)
        } else {
          vm.$store.dispatch('users/loadProfile').then(function (res) {
            vm.validateProfile(res)
          })
        }
      },
    },
  }
</script>
<style lang="scss">
  #core-navigation-drawer{
    overflow: visible;
  }
  .support-button{
    &:hover{
      cursor: pointer;
      .v-img{
        transition: 0.3s;
        transform: scale(1.1);
      }
    }
  }
  .tutorial-alert{
    position: fixed;
    width: 350px;
    min-width: 350px;
    max-width: 350px;
    right: -360px;
    z-index:1;
    margin-top: -125px;
    &:after{
      content:'';
      position:absolute;
      left: -20px;
      width: 40px;
      height: 40px;
      top: 50%;
      bottom: 50%;
      transform: rotate(45deg);
      background-color: inherit;
      margin: auto;
      z-index: -1;
    }

  }

</style>
<!--<style lang="sass">-->

  <!--@import '~vuetify/src/styles/tools/_rtl.sass'-->
  <!--#core-navigation-drawer-->
    <!--&.v-navigation-drawer&#45;&#45;mini-variant-->
      <!--.v-list-item-->
        <!--justify-content: flex-start !important-->

      <!--.v-list-group&#45;&#45;sub-group-->
        <!--display: block !important-->

    <!--.v-list-group__header.v-list-item&#45;&#45;active:before-->
      <!--opacity: .24-->

    <!--.v-list-item-->
      <!--&__icon&#45;&#45;text,-->
      <!--&__icon:first-child-->
        <!--justify-content: center-->
        <!--text-align: center-->
        <!--width: 20px-->

        <!--+ltr()-->
          <!--margin-right: 24px-->
          <!--margin-left: 12px !important-->

        <!--+rtl()-->
          <!--margin-left: 24px-->
          <!--margin-right: 12px !important-->

    <!--.v-list&#45;&#45;dense-->
      <!--.v-list-item-->
        <!--&__icon&#45;&#45;text,-->
        <!--&__icon:first-child-->
          <!--margin-top: 10px-->

    <!--.v-list-group&#45;&#45;sub-group-->
      <!--.v-list-item-->
        <!--+ltr()-->
          <!--padding-left: 8px-->

        <!--+rtl()-->
          <!--padding-right: 8px-->

      <!--.v-list-group__header-->
        <!--+ltr()-->
          <!--padding-right: 0-->

        <!--+rtl()-->
          <!--padding-right: 0-->

        <!--.v-list-item__icon&#45;&#45;text-->
          <!--margin-top: 19px-->
          <!--order: 0-->

        <!--.v-list-group__header__prepend-icon-->
          <!--order: 2-->

          <!--+ltr()-->
            <!--margin-right: 8px-->

          <!--+rtl()-->
            <!--margin-left: 8px-->
<!--</style>-->
